angular.module(["ng"]).run(["$templateCache", function (c) {
    c.put("talk-widget-template.html", "<div ng-if=\"call\"> <dialpad-widget data-status=\"getStatus()\" data-muted=\"call.isMute\" on-dial=\"dtmf($event)\" on-mute=\"mute()\" on-leave=\"close()\" data-title=\"getTitle()\"></dialpad-widget> </div>");
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/talk-widget/talk-widget-template.html
 ** module id = 181
 ** module chunks = 0
 **/